/* eslint-disable @typescript-eslint/no-explicit-any */
// import { IMessage } from '@/features/case/_deprecated/api/get-event';
// import { ICaseLabel } from '@/features/settings/label/types/case-label.type';
// import { ICaseLabel } from '@/features/settings/label/api/label-case/get-label-case';
// import { IChatLabel } from '@/features/settings/label/types/chat-label.type';
// import { IChatLabel } from '@/features/settings/label/api/label-chat/get-label-chat';
// import { ICustomerLabel } from '@/features/settings/label/types/customer-label.type';
import { ILabelCase } from '@/features/settings/label/label-case/type/label-case.type';
import { ILabelChat } from '@/features/settings/label/label-chat/types/label-chat.type';
import { ILabelCustomer } from '@/features/settings/label/label-customer/types/label-customer.type';
import { TAgent } from '@/features/settings/manage-agent-team/agent/types/agent.type';
import { TTeam } from '@/features/settings/manage-agent-team/team/types/team.type';
// import { ILabelCustomer } from '@/features/settings/label/label-customer/types/label-customer.type';
// import { IAgent } from '@/features/settings/manage-agent-team/api/get-agent';
// import { ITeams } from '@/features/settings/manage-agent-team/api/get-team';
import { IOnlineUser } from '@/types/general.type';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type TLabel = ILabelCustomer | ILabelChat | ILabelCase;

interface IFilterChatList {
  labels: TLabel[];
  channels: any[];
  agents: TAgent[];
  teams: TTeam[];
  searchCustomer: string;
}

interface AppStore {
  lastChatIndex: number;
  setLastChatIndex: (index: number) => void;

  messagesByCase: Record<string, any[]>;
  addMessages: (messages: any[]) => void;

  selectedCaseId: string | null;
  setSelectedCaseId: (caseId: string) => void;

  onlineUsers: IOnlineUser[];
  setOnlineUsers: (users: IOnlineUser[]) => void;

  pendingMessageIds: string[];
  setPendingMessageIds: (ids: string[]) => void;

  filterChatList: IFilterChatList;
}

const initialFilterChatList: IFilterChatList = {
  labels: [],
  channels: [],
  agents: [],
  teams: [],
  searchCustomer: '',
};

export const useStore = create<AppStore>()(
  devtools(
    immer((set) => ({
      lastChatIndex: 0,
      setLastChatIndex: (index: number) => set({ lastChatIndex: index }),
      messagesByCase: {},
      addMessages: (messages: any[]) =>
        set((state) => {
          messages.forEach((message) => {
            if (!state.messagesByCase[message.caseId]) {
              state.messagesByCase[message.caseId] = [];
            }

            const messageExists = state.messagesByCase[message.caseId].some((m) => m.messageId === message.messageId);

            if (!messageExists) {
              state.messagesByCase[message.caseId].push(message);
            }
          });

          state.lastChatIndex = messages[messages.length - 1].messageOrder;
        }),
      selectedCaseId: null,
      setSelectedCaseId: (caseId: string) =>
        set((state) => {
          state.selectedCaseId = caseId;
        }),
      onlineUsers: [],
      setOnlineUsers: (users: IOnlineUser[]) =>
        set((state) => {
          state.onlineUsers = users;
        }),
      pendingMessageIds: [],
      setPendingMessageIds: (ids: string[]) =>
        set((state) => {
          state.pendingMessageIds = ids;
        }),
      filterChatList: initialFilterChatList,
      setFilterChatList: (filterChatList: IFilterChatList) =>
        set((state) => {
          state.filterChatList = filterChatList;
        }),
    }))
  )
);
